<nx-selectable-card appearance="expert">
  <nx-card-header  *ngIf="!isOnline">
    <app-title [desktopTitle]="'SUMMARY'" [padding]="'30px 0px 5px 0px'"></app-title>
    <hr />
  </nx-card-header >
  <div *ngIf="!isOnline">
    <nx-small-stage>
      <h1 nxHeadline="subsection-small" class="nx-font-weight-bold">
        Hello {{ sellPolicyData.customerFirstName }} ,
      </h1>
      <h3 nxHeadline="subsection-xsmall">
        Policy Details for the <b> {{ sellPolicyData.policyName }} </b> policy.
      </h3>
      <nx-small-stage-image nxSmallStageImageStart
        src="assets/illustrations/small-stage-image-start.svg"></nx-small-stage-image>
      <nx-small-stage-image nxSmallStageImageEnd
        src="assets/illustrations/small-stage-image-end.svg"></nx-small-stage-image>
      <nx-small-stage-image nxSmallStageImageBottom class="nx-hidden-s nx-hidden-xs"
        src="assets/illustrations/small-stage-image-narrow-screen.svg"></nx-small-stage-image>
    </nx-small-stage>
    <div nxLayout="grid" style="background-color: #dcedf0;">
      <div nxRow nxRowAlignItems="center,center,center">
        <div nxCol="12,12,10" nxColOffset="1" style="text-align: left; font-size: medium;" class="nx-margin-top-2m nx-font-weight-bold">
          <div class="scroll-container">
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,12" >
                <h1 nxHeadline="subsection-small" class="nx-margin-bottom-2m" style="color:rgb(34, 145, 236)">Plan
                  Details</h1>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Purchased Plan &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{ planName }} </div>         
                </div>
                <hr />
              </div>
           
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5"> Basic Price (Excluding GST) &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">₹ &nbsp; {{ basicPrice }}</div>           
                </div>
                <hr />
              </div>     
            </div>
         
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5"> Maximum Vehicle Age &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{ maximumVehicleAge }}</div>
                </div>
                <hr />
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5"> Number of Duration &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{ durationOfPlan }}</div>
                </div>
                <hr />
              </div>
            </div>
            <!-- Vehicle Details -->
            <div nxRow nxRowAlignItems="center,center,center" class="nx-margin-top-2m">
              <div nxCol="12,12,12" >
                <h1 nxHeadline="subsection-small" class="nx-margin-bottom-2m" style="color:rgb(34, 145, 236)">Vehicle
                  Details</h1>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5"> VIN(Chasis Number) &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.vinChassisNo}}</div>
                </div>
                <hr />
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5"> Registration Number &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.licensePlateNo}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Model &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.model}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Color &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.colorName}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Vehicle Purchase Date &nbsp;
                  <br><span nxFormfieldHint style="font-size: 12px;font-weight: lighter;">(DD/MM/YYYY)</span>
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.vehicleSaleDate | date:'dd/MM/yyyy'}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Age of Vehicle (Years) &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.ageOfVehicle}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Policy Sale/Invoice Date &nbsp;
                    <br><span nxFormfieldHint style="font-size: 12px;font-weight: lighter;">(DD/MM/YYYY)</span>
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.invoiceDate | date:'dd/MM/yyyy'}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Variant &nbsp;
                    <br><span nxFormfieldHint style="font-size: 12px;font-weight: lighter;">&nbsp;</span>
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.variant}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <!-- Custromer Details -->
            <div nxRow nxRowAlignItems="center,center,center" class="nx-margin-top-2m">
              <div nxCol="12,12,12" >
                <h1 nxHeadline="subsection-small" class="nx-margin-bottom-2m" style="color:rgb(34, 145, 236)">Customer
                  Details</h1>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">First Name &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.customerFirstName}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Middle Name &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.customerMiddleName}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Last Name &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.customerLastName}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Home Phone Number &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.customerPhoneNo}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">GST Number &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.custGstNumber}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Mobile Number &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.customerMobileNo}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Email &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.customerEmail}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Customer Address &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.customerAddress}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">State &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{stateName}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6" style="vertical-align: top;">
                <div nxRow>
                  <div nxCol="12,12,5">City &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{cityName}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">PIN Code &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.pincode}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
              </div>
            </div>
            <!-- Payment Details -->
            <div nxRow nxRowAlignItems="center,center,center" class="nx-margin-top-2m">
              <div nxCol="12,12,12">
                <h1 nxHeadline="subsection-small" class="nx-margin-bottom-2m" style="color:rgb(34, 145, 236)">Payment
                  Details</h1>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Selling Advisor &nbsp;
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.soldBy}}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Selling Advisor Phone Number &nbsp;</div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6"> {{sellPolicyData.soldByNumber}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Payment Date &nbsp;
                    <br><span nxFormfieldHint style="font-size: 12px;font-weight: lighter;">(DD/MM/YYYY)</span>
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.paymentDate | date:'dd/MM/yyyy' }}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">(Unit Price + GST Price) &nbsp;
                    <br><span nxFormfieldHint style="font-size: 12px;font-weight: lighter;">&nbsp;</span>
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">₹ &nbsp; {{sellPolicyData.unitPrice}}</div>
                </div>
                <hr/>
              </div>
            </div>
            <div nxRow nxRowAlignItems="center,center,center">
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Policy Start Date &nbsp;
                    <br><span nxFormfieldHint style="font-size: 12px;font-weight: lighter;">(DD/MM/YYYY)</span>
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.effectiveDate | date:'dd/MM/yyyy' }}</div>
                </div>
                <hr/>
              </div>
              <div nxCol="12,12,6">
                <div nxRow>
                  <div nxCol="12,12,5">Policy End Date &nbsp;
                    <br><span nxFormfieldHint style="font-size: 12px;font-weight: lighter;">(DD/MM/YYYY)</span>
                  </div>
                  <div nxCol="12,12,1">:</div>
                  <div nxCol="12,12,6">{{sellPolicyData.expiryDate | date:'dd/MM/yyyy'}}</div>
                </div>
                <hr/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div nxRow class="nx-margin-top-2m">
        <div nxCol="12" style="text-align: center;">
          <button nxButton="cta" type="button" (click)="buyNow()"> Buy Policy
          </button>
        </div>
      </div>
    </div>
  </div>

  <nx-card-header  *ngIf="isOnline">
    <nx-small-stage class="nx-margin-bottom-m small-header">
      <nx-small-stage-image
        nxSmallStageImageEnd
        class="small-header-img"
        src="/assets/illustrations/man_pointing_at_certificates_1.png"
      ></nx-small-stage-image>
      <h2
        nxHeadline="subsection"
        class="nx-font-weight-regular"
        *ngIf="isOnline"
      >
        Success
      </h2>
    </nx-small-stage>
  </nx-card-header>
  <div nxLayout="grid" class="docs-grid-colored-grid card-content">
    <div nxRow nxRowAlignItems="center" nxRowJustify="start,start,around" *ngIf="isOnline">
        <div nxCol="12" class="payment-bg"></div>
        <div nxCol="12" style="text-align: center" class="nx-margin-top-xs">
          <nx-label
            >Policy created successfully and awaiting for payment.</nx-label
          >
        </div>
        <div nxCol="12" style="text-align: center" class="nx-margin-top-xs">
          <nx-badge vibrant type="active"
            >Please complete the payment for policy download.</nx-badge
          >
        </div>
        <div nxCol="12" style="text-align: center" class="nx-margin-top-xs">
          <button
          nxButton="secondary small-medium"
          type="button"
          style="border-radius: 20px;"
          (click)="checkPaymentStatus()"
        >
          <nx-icon name="clock-o" class="nx-margin-right-s"></nx-icon>Check Payment Status
        </button>
        </div>
        <div nxCol="12" style="text-align: center" class="nx-margin-top-xs">
          <button
            nxButton="tertiary"
            type="button"
            [routerLink]="['/sellpolicy']"
          >
            <nx-icon name="product-house" class="nx-margin-right-s"></nx-icon>Go
            Home
          </button>
        </div>
    </div>
  </div>

  <form #onePayuForm ngNoForm [action]="payuUrl" method="POST" target="_blank" *ngIf="paymentForm">
    <div>
      <!-- HiddenFields -->
      <input type="hidden" name="amount" [(ngModel)]="payuinput.amount" />
      <input type="hidden" name="phone" [(ngModel)]="payuinput.phone" />
      <input type="hidden" name="key" [(ngModel)]="payuinput.key" />
      <input type="hidden" name="txnid" [(ngModel)]="payuinput.txnid" />
      <input type="hidden" name="productinfo" [(ngModel)]="payuinput.productinfo" />
      <input type="hidden" name="email" [(ngModel)]="payuinput.email" />
      <input type="hidden" name="firstname" [(ngModel)]="payuinput.firstname" />
      <input type="hidden" name="surl" [(ngModel)]="payuinput.surl" />
      <input type="hidden" name="furl" [(ngModel)]="payuinput.furl" />
      <input type="hidden" name="hash" [(ngModel)]="payuinput.hash" />
    </div>
  </form>
  <nx-card-footer>
    <nx-link>
      <a>
        <nx-icon name='product-pages-documents'></nx-icon>
        Step 5/5 <span style="color: green;"> &nbsp; Policy Summary</span>
      </a>
    </nx-link>
  </nx-card-footer>
</nx-selectable-card>